module.exports = __webpack_public_path__ + "img/iran-network.0fabddfe.svg";